import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Transition as _Transition, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/images/circle-error.svg'
import _imports_1 from '@/images/copy.svg'
import _imports_2 from '@/images/top-right-green-arrow.png'


const _hoisted_1 = { class: "flex items-center flex-1" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "h-5 w-5 cursor-pointer mr-1",
  alt: "white error"
}, null, -1)
const _hoisted_3 = {
  key: 1,
  class: "flex items-center cursor-pointer justify-between flex-1"
}
const _hoisted_4 = { class: "flex items-center justify-center" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["data-clipboard-text"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "w-5 h-5",
  alt: "copy"
}, null, -1)
const _hoisted_8 = {
  key: 0,
  class: "py-1.5 px-4 rounded-lg text-permaGreen7 bg-permaGreen5 absolute bottom-8 text-14px whitespace-nowrap"
}
const _hoisted_9 = ["href"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "w-5 h-5",
  alt: "deposit arrow"
}, null, -1)
const _hoisted_11 = { class: "" }
const _hoisted_12 = {
  key: 0,
  class: "mb:px-6 px-4"
}
const _hoisted_13 = { class: "flex text-14px justify-start items-center py-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "w-px h-3 bg-permaWhite mx-3" }, null, -1)
const _hoisted_15 = { class: "pr-1.5" }

import { computed, onMounted, ref, watch, Ref, onUnmounted } from 'vue'
import Sidebar from '../Sidebar.vue'
import { useI18n } from 'vue-i18n'
import { useStore } from '@/store'
import UserInfo from './UserInfo.vue'
import ClipboardJS from 'clipboard'
import BtnArea from '../BtnArea.vue'
import TokenSelect from '../TokenSelect.vue'
import { Token } from '@/libs/everpay-js'
import { disconnectWebsite } from '@/libs/everpay'
import { permaMessage } from '../Message'
import TitleArea from '@/components/TitleArea.vue'
import { getSearchAddrNFTs } from '@/libs/api'
import { formatInputPrecision } from '@/libs/util'
import { toBN } from '@/libs/everpay-js/utils/util'
import { isProd } from '@/constants'
import { formatAmountThreeDigits } from '@/pages/swap/index'
import MoreInfo from '@/components/common/MoreInfo.vue'

interface Props {
  visible: boolean
  title: string
  shortAccount: string
}
interface Emits {
(e:'close'):void
}

export default /*#__PURE__*/_defineComponent({
  props: {
    visible: null,
    title: null,
    shortAccount: null
  },
  emits: ["close"],
  setup(__props: any, { emit: emits }: { emit: ({
(e:'close'):void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  visible: boolean
  title: string
  shortAccount: string
}



const displayAssetsBalance = ref(false)
const { t } = useI18n()
const store = useStore()
const account = computed(() => store.state.account)
const isLpSame = computed(() => store.state.isLpAddressSame)
const connecting = computed(() => store.state.connectingModalVisible)
const showConnectModal = () => {
  store.commit('updateConnectModalVisible', true)
}
const disconnect = () => {
  emits('close')
  disconnectWebsite(store)
  permaMessage({
    showClose: true,
    message: t('disconnect_success'),
    type: 'success'
  })
}
const accountNftsNum = ref(0)
watch(() => account.value, async () => {
  if (account.value) {
    try {
      const [ethNft, arNft] = await Promise.all([getSearchAddrNFTs(account.value.toLocaleLowerCase()), getSearchAddrNFTs(account.value)])
      accountNftsNum.value = ethNft.length + arNft.length
    } catch {
      accountNftsNum.value = 0
    }
  } else {
    accountNftsNum.value = 0
  }
}, {
  immediate: true
})
const toSwap = (symbol:string) => {
  window.open(`https://app${isProd ? '' : '-dev'}.permaswap.network/USDC-${symbol.toUpperCase()}`)
}
const currencyPricesStack: Ref<any> = computed(() => {
  const result = {}
  store.state.currencyPrices.forEach(currencyPriceItem => {
    (result as any)[currencyPriceItem.symbol] = currencyPriceItem.price
  })
  return result
})
const totalAssetsPrice = computed(() => {
  return !account.value
    ? '-'
    : balances.value.reduce((memo: number, item: any) => {
      return memo + item.currencyPrice
    }, 0).toFixed(2)
})
const tokens = computed(() => store.getters.tokens as Token[])
const balances = computed(() => {
  return tokens.value.map((t: Token) => {
    const balanceItem = store.state.everpayBalances.find(item => item.tag?.toUpperCase() === t.tag.toUpperCase())
    // 只展示8位小数
    const balance = !account.value ? '-' : (balanceItem ? formatInputPrecision(toBN(balanceItem.balance).toString(), 8) : '0')
    const currencyPrice = !account.value ? '0' : currencyPricesStack.value[t.symbol] * (balance as any)
    return {
      currencyPrice
    }
  })
})
const updateAllBalance = () => {
  if (tokens.value.length) {
    store.dispatch('updateEverpayBalancesAsync')
  }
}
watch([account, tokens], updateAllBalance)
watch(() => props.visible, async () => {
  if (props.visible) {
    updateAllBalance()
    intervalUpdatePrices()
  } else {
    clearIntervalUpdatePrices()
  }
})
let intervalUpdatePricesTimer = null as any
const clearIntervalUpdatePrices = () => {
  clearTimeout(intervalUpdatePricesTimer)
}
const intervalUpdatePrices = async () => {
  clearIntervalUpdatePrices()
  try {
    if (store.state.account) {
      await store.dispatch('updateCurrencyPricesAsnyc')
    }
  } finally {
    intervalUpdatePricesTimer = setTimeout(intervalUpdatePrices, 15000)
  }
}

let clipboard: any
const copySuccess = ref(false)
let timer:any = null
onMounted(() => {
  clipboard = new ClipboardJS('.clipboard-modal-account')
  clipboard.on('success', function (e: any) {
    e.clearSelection()
    copySuccess.value = true
    timer && clearTimeout(timer)
    timer = setTimeout(() => {
      copySuccess.value = false
    }, 2000)
  })
})
onUnmounted(() => {
  clipboard && clipboard.destroy()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Sidebar, {
    visible: __props.visible,
    onClose: _cache[3] || (_cache[3] = ($event: any) => (emits('close')))
  }, {
    title: _withCtx(() => [
      _createVNode(TitleArea, {
        onClose: _cache[0] || (_cache[0] = ($event: any) => (emits('close')))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_unref(isLpSame))
              ? (_openBlock(), _createBlock(MoreInfo, { key: 0 }, {
                  icon: _withCtx(() => [
                    _hoisted_2
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString(_unref(t)('new_swap.err_invalid_swap_user')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(__props.title) + " ", 1),
            (_unref(account))
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("a", {
                      href: `https://scan${_unref(isProd) ? '' : '-dev'}.everpay.io/account/${_unref(account)}`,
                      target: "_blank",
                      class: "flex items-center mx-1"
                    }, " (" + _toDisplayString(__props.shortAccount) + ")", 9, _hoisted_5),
                    _createElementVNode("div", {
                      class: "flex relative justify-center clipboard-modal-account",
                      "data-clipboard-text": _unref(account)
                    }, [
                      _hoisted_7,
                      _createVNode(_Transition, { name: "fade" }, {
                        default: _withCtx(() => [
                          (copySuccess.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(t)('replicated')), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ], 8, _hoisted_6)
                  ]),
                  _createVNode(MoreInfo, { "content-class": "right-5 bottom-4 z-40 w-80" }, {
                    info: _withCtx(() => [
                      _createElementVNode("a", {
                        href: `https://app${_unref(isProd) ? '' : '-dev'}.everpay.io/deposit`,
                        target: "_blank",
                        class: "py-1 sm:px-4 px-1 mr-1 text-14px border border-permaGreen2 hover:border-permaGreen11 active:border-permaGreen9 border-opacity-25 rounded-lg text-permaGreen4 hover:text-permaGreen11 active:text-permaGreen9 flex items-center sm:mr-3 transition-colors"
                      }, [
                        _createTextVNode(_toDisplayString(_unref(t)('deposit')) + " ", 1),
                        _hoisted_10
                      ], 8, _hoisted_9)
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" " + _toDisplayString(_unref(t)('deposit_msg')), 1)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", {
          class: _normalizeClass(["bg-permaGreen bg-opacity-50", !_unref(account) ? 'py-6' : ''])
        }, [
          (!_unref(account))
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(BtnArea, {
                  class: "text-black bg-permaGreen4 hover:bg-permaGreen11 active:bg-permaGreen9",
                  onClick: showConnectModal
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(connecting) ? _unref(t)('connecting') : _unref(t)('connect')), 1)
                  ]),
                  _: 1
                })
              ]))
            : (_openBlock(), _createBlock(UserInfo, {
                key: 1,
                class: "userInfo px-6",
                amount: _unref(formatAmountThreeDigits)(_unref(totalAssetsPrice)),
                "display-assets-balance": displayAssetsBalance.value,
                "nft-num": accountNftsNum.value,
                onClose: _cache[1] || (_cache[1] = ($event: any) => (emits('close'))),
                onSwitch: _cache[2] || (_cache[2] = ($event: any) => (displayAssetsBalance.value = !displayAssetsBalance.value))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", {
                      class: "text-permaGreen4 cursor-pointer hover:text-permaGreen11 active:text-permaGreen9 transition-colors",
                      onClick: disconnect
                    }, _toDisplayString(_unref(t)('disconnect')), 1),
                    _hoisted_14,
                    _createElementVNode("div", {
                      class: "text-permaGreen4 cursor-pointer hover:text-permaGreen11 active:text-permaGreen9 transition-colors",
                      onClick: showConnectModal
                    }, _toDisplayString(_unref(t)('change_account')), 1)
                  ])
                ]),
                _: 1
              }, 8, ["amount", "display-assets-balance", "nft-num"]))
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(TokenSelect, {
          tokens: _unref(tokens),
          "display-assets-balance": displayAssetsBalance.value,
          "selected-token": null,
          "select-title": _unref(t)('asset'),
          "is-modal": false,
          onToSwap: toSwap
        }, null, 8, ["tokens", "display-assets-balance", "select-title"])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})